import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { VechicleService } from '../vehicle.service';
import VehicleAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity';
import { LOCALIZED_PROPERTIES, VEHICLE_EXPORT_ID, VEHICLE_TITLE } from './vechicle.constants';

@Injectable()
export class VehicleExport {
  constructor(
    private exportService: ExportService,
    private vehicleService: VechicleService,
  ) {}

  private transformItem(item: VehicleAttributes) {
    return {
      code: get(item, 'code', ''),
      externalKeys: get(item, 'externalKeys.code', ''),
      name: get(item, 'name', ''),
      brand: get(item, 'brand', ''),
      plate: get(item, 'plate', ''),
      type: get(item, 'type.name', ''),
      description: get(item, 'description', ''),
      company: get(item, 'type.company.name', ''),
      businessPartner: get(item, 'businessPartner.name', ''),
      ownership: item.isOwn ? 'Propio' : 'Externo', 
      height: get(item, 'dimensions.height', ''),
      width: get(item, 'dimensions.width', ''),
      length: get(item, 'dimensions.length', ''),
      dimensionUnitOfMeasure: get(item, 'dimensions.dimensionUnitOfMeasure.name', ''),
      grossWeight: get(item, 'dimensions.grossWeight', ''),
      netWeight: get(item, 'dimensions.netWeight', ''),
      weightUnitOfMeasure: get(item, 'dimensions.weightUnitOfMeasure.name', ''),
      volume: get(item, 'dimensions.volume', ''),
      volumeUnitOfMeasure: get(item, 'dimensions.volumeUnitOfMeasure.name', ''),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: VEHICLE_EXPORT_ID,
      title: VEHICLE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(VEHICLE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.vehicleService.findByFilter(buildQuery(
          seed(this.vehicleService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(VEHICLE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(VEHICLE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
